<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" v-on:keyup.enter="$refs.table.refresh(true)">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="供应商名称">
              <a-input v-model="queryParam.supplierName" />
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="税率承担方">
              <a-select v-model="queryParam.taxpayer" allowClear="true">
                <a-select-option value="0">供应商</a-select-option>
                <a-select-option value="1">锁安</a-select-option>
                <a-select-option value="2">双方</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="是否开票">
              <a-select v-model="queryParam.invoice" allowClear="true">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="联系方式">
              <a-input v-model="queryParam.phonenumber" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="付款方式" style="margin-left: 12px">
              <a-select v-model="queryParam.payment" allowClear="true">
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="发票类型" style="margin-left: 12px">
              <a-select v-model="queryParam.invoiceType" allowClear="true">
                <a-select-option value="1">增值税普票</a-select-option>
                <a-select-option value="2">增值税专票</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="新建时间">
              <a-date-picker @change="onChangeTiem" v-model="times" />
              <!--              <a-input v-model="queryParam.taxPoint"/>-->
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="新建人" style="margin-left: 14px">
              <a-input v-model="queryParam.createBy" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="配件类型" style="margin-left: 12px">
              <a-select v-model="queryParam.accessoryType" :allowClear="true">
                <a-select-option v-for="type in dataType" :title="type.accessoryType" :key="type.accessoryType">{{
                  type.accessoryType
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="配件名称" style="margin-left: 12px">
              <a-select v-model="queryParam.accessoryName" :allowClear="true">
                <a-select-option v-for="type in dataName" :title="type.accessoryName" :key="type.accessoryName">{{
                  type.accessoryName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="配件型号" style="margin-left: 12px">
              <a-select v-model="queryParam.accessoryCategory" :allowClear="true">
                <a-select-option
                  v-for="type in dataCategory"
                  :title="type.accessoryCategory"
                  :key="type.accessoryCategory"
                  >{{ type.accessoryCategory }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="配件规格">
              <a-select v-model="queryParam.accessorySpecification" :allowClear="true">
                <a-select-option
                  v-for="type in dataSpecification"
                  :title="type.accessorySpecification"
                  :key="type.accessorySpecification"
                  >{{ type.accessorySpecification }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="6">
            <a-row>
              <a-form-item label="所在地址" style="margin-left: 12px">
                <a-col :span="12">
                  <a-select v-model="queryParam.currentProvince" @change="onchange2" :allowClear="true">
                    <a-select-option
                      v-for="type in selectAllProvince2"
                      :title="type.provinceName"
                      :key="type.provinceCode"
                      >{{ type.provinceName }}</a-select-option
                    >
                  </a-select>
                </a-col>
                <a-col :span="12">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="queryParam.currentCity" :allowClear="true">
                      <a-select-option v-for="type in selectCityName2" :title="type.cityName" :key="type.cityCode">{{
                        type.cityName
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-form-item>
            </a-row>
          </a-col>
          <a-col :span="6">
            <a-row>
              <a-form-item label="发货地址" style="margin-left: 12px">
                <a-col :span="12">
                  <a-select v-model="queryParam.deliveryProvince" @change="onchange3" :allowClear="true">
                    <a-select-option
                      v-for="type in selectAllProvince2"
                      :title="type.provinceName"
                      :key="type.provinceCode"
                      >{{ type.provinceName }}</a-select-option
                    >
                  </a-select>
                </a-col>
                <a-col :span="12">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="queryParam.deliveryCity" :allowClear="true">
                      <a-select-option v-for="type in selectCityName3" :title="type.cityName" :key="type.cityCode">{{
                        type.cityName
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-form-item>
            </a-row>
          </a-col>

          <span class="table-page-search-submitButtons">
            <a-row type="flex" justify="space-between">
              <a-col :span="15"></a-col>
              <a-col :span="6" style="text-align: right">
                <a-button style="margin-right: 8px" type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="handClear">清空</a-button>
              </a-col>
            </a-row>
          </span>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-divider />
      <a-row type="flex" justify="space-between">
        <a-col :span="16"></a-col>
        <a-col :span="4" style="text-align: right">
          <a-button v-if="addEnable" type="primary" icon="plus" @click="$refs.modal.add()">新建</a-button>
        </a-col>
        <a-dropdown v-if="removeEnable && selectedRowKeys.length > 0">
          <a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>
        </a-dropdown>
      </a-row>
    </div>
    <s-table
      size="default"
      ref="table"
      rowKey="supplierId"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: '1600px' }"
      bordered
    >
      <span slot="invoice" slot-scope="text, record">
        <a-text v-if="record.invoice == 0">不开票</a-text>
        <a-text v-else="record.invoice == 1">开票</a-text>
      </span>

      <span slot="invoiceType" slot-scope="text, record">
        <a-text v-if="record.invoiceType == 0">无 </a-text>
        <a-text v-else-if="record.invoiceType == 1">增值税普票</a-text>
        <a-text v-else="record.invoiceType == 2">增值税专票</a-text>
      </span>

      <span slot="taxpayer" slot-scope="text, record">
        <a-text v-if="record.taxpayer == 0">供应商 </a-text>
        <a-text v-else-if="record.taxpayer == 1">锁安</a-text>
        <a-text v-else="record.taxpayer == 2">双方</a-text>
      </span>

      <span slot="payment" slot-scope="text, record">
        <a-text v-if="record.payment == 0">先付款 </a-text>
        <a-text v-else="record.payment == 1">后付款</a-text>
      </span>

      <span slot="forbiddenStatus" slot-scope="text, record">
        <a-text v-if="record.forbiddenStatus == 0">启用 </a-text>
        <a-text v-else="record.forbiddenStatus == 1">禁用</a-text>
      </span>

      <span slot="action" slot-scope="text, record">
        <a v-if="detailsEnabel" @click="detailBtn(record.supplierId)">详情</a>
        <a-divider type="vertical" />
        <a v-if="editEnabel" @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="delById(record)" v-if="record.forbiddenStatus == 0 && editEnabel">禁用</a>
        <a @click="delById(record)" v-if="record.forbiddenStatus == 1 && editEnabel">启用</a>
        <a-divider type="vertical" />
        <a v-if="removeEnable" @click="delByIds(record)">删除</a>
      </span>
    </s-table>
    <supplier-modal ref="modal" @ok="handleOk(arguments, userDefined)" />

    <a-modal
      title="详情"
      style="top: 20px;"
      :width="1000"
      v-model="dateModel"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit2"
      okText="确定"
    >
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商名称">
        <a-input v-model="boxLis.supplierName" disabled="disabled" />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="负责人">
        <a-input v-model="boxLis.personCharge" disabled="disabled" />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系方式">
        <a-input v-model="boxLis.phonenumber" disabled="disabled" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所在省">
        <a-select @change="onchange2" v-model="boxLis.currentProvince" disabled="disabled">
          <a-select-option v-for="item in selectAllProvince2" :value="item.provinceCode">{{
            item.provinceName
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所在市">
        <a-select @change="onchange2" v-model="currentCity2" disabled="disabled">
          <a-select-option v-for="item in selectCityName2" :value="item.cityCode">{{ item.cityName }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货省">
        <a-select @change="onchange2" v-model="boxLis.deliveryProvince" disabled="disabled">
          <a-select-option v-for="item in selectAllProvince2" :value="item.provinceCode">{{
            item.provinceName
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货市">
        <a-select @change="onchange2" v-model="deliveryCity2" disabled="disabled">
          <a-select-option v-for="item in selectCityName3" :value="item.cityCode">{{ item.cityName }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
        <a-input v-model="boxLis.invoice" disabled="disabled" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发票类型">
        <a-input v-model="boxLis.invoiceType" disabled="disabled" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="税率承担方">
        <a-input v-model="boxLis.taxpayer" disabled="disabled" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="户名">
        <a-input v-model="boxLis.accountName" disabled="disabled" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行账号">
        <a-input v-model="boxLis.accountNumber" disabled="disabled" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
        <!--<a-input v-model="boxLis.bankName"  disabled="disabled"/>-->
        <a-select
          showSearch
          optionFilterProp="children"
          v-model="boxLis.bankName"
          :filterOption="filterOption"
          disabled="disabled"
          allowClear="true"
        >
          <a-select-option v-for="item of bankName" :title="item.name" :key="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
        <a-input v-model="boxLis.payment" disabled="disabled" />
      </a-form-item>

      <div><button type="button" @click="detailBtn2">查看配件</button></div>
    </a-modal>
    <a-modal
      title="配件详情"
      style="top: 20px;"
      :width="950"
      v-model="visible2"
      :confirmLoading="confirmLoading"
      :maskClosable="false"
      @ok="handleSubmit3"
    >
      <a-form>
        <a-row :gutter="16">
          <a-col :span="5">
            <a-button type="primary" ghost @click="handleadd1" :disabled="isDisable1" disabled="disabled"
              >添加配件</a-button
            >
          </a-col>
        </a-row>

        <div v-for="(item2, i) in supplierAreas" :key="i">
          <a-row :gutter="16">
            <a-col :span="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件名称">
                <a-select @change="onChange3(i)" v-model="item2.supplierAccessory.accessoryId" disabled="disabled">
                  <a-select-option v-for="item in data2" :title="item.accessoryName" :value="item.accessoryId"
                    >{{ item.accessoryType }} _ {{ item.accessoryName }} _ {{ item.accessoryCategory }} _
                    {{ item.accessorySpecification }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!--          <a-col :span="5">-->
            <!--            <a-button  style="margin-left: 60%;" type="primary" ghost @click="handleadd2(i)" :disabled="isDisable1">添加</a-button>-->
            <!--          </a-col>-->
          </a-row>

          <a-row v-for="(item, ii) in supplierAreas[i].supplierUnities" :key="ii">
            <a-col :span="7">
              <a-form-item label="进货价" :labelCol="labelCol" :wrapperCol="wrapperCol" disabled="disabled">
                <a-input v-model="item.price" style="" disabled="disabled" />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="数量区间" :labelCol="labelCol" :wrapperCol="wrapperCol" disabled="disabled">
                <a-input v-model="item.priceUnit" style="" disabled="disabled" />
              </a-form-item>
            </a-col>

            <a-col :span="5">
              <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" disabled="disabled">
                <a-input v-model="item.remark" style="" disabled="disabled" />
              </a-form-item>
            </a-col>
            <a-col :span="4">
              <a-button type="danger" ghost @click="removeTab1(i, ii)" :disabled="isDisable3" disabled="disabled"
                >删除</a-button
              >
              <a-button type="primary" ghost style="margin-left:5px" @click="handleadd2(i)" disabled="disabled"
                >添加</a-button
              >
            </a-col>
          </a-row>
        </div>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import {
  selectAccessorySpecification,
  selectAccessoryCategory,
  selectAccessoryName,
  selectAccessoryType,
  selectaccessory,
  selectAllProvince,
  selectCityName,
  getSupplierList,
  delSupplier,
  detailsSupplier,
  forbiddenSupplier,
  getonesupplier
} from '@/api/accessory/supplier'
import SupplierModal from './modules/SupplierModal.vue'
import { checkPermission } from '@/utils/permissions'

export default {
  name: 'TableList',
  components: {
    STable,
    SupplierModal
  },
  data() {
    return {
      times: '',
      // 配件规格列表
      dataSpecification: '',
      // 配件型号列表
      dataCategory: '',
      // 配件名称列表
      dataName: '',
      // 配件类型列表
      dataType: '',

      visible2: false,
      // 配件列表
      data2: '',
      // 发货市
      deliveryCity2: '',
      // 所在市
      currentCity2: '',
      // 所有 所在市
      selectCityName3: '',

      selectCityName2: '',
      // 省
      selectAllProvince2: '',
      createTime: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      mdl: {},
      boxLis: '',
      delFlag: 1,
      dateModel: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数

      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'num',
          align: 'center'
        },
        {
          title: '操作',
          width: '200px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '供应商名称',
          dataIndex: 'supplierName',
          align: 'center'
        },
        {
          title: '联系方式',
          dataIndex: 'phonenumber',
          align: 'center'
        },
        // {
        //   title: '所在省',
        //   dataIndex: 'currentProvince'
        // },
        {
          title: '所在市',
          dataIndex: 'currentCity',
          align: 'center'
        },
        // {
        //   title: '发货省',
        //   dataIndex: 'deliveryProvince'
        // },
        {
          title: '发货市',
          dataIndex: 'deliveryCity',
          align: 'center'
        },
        {
          title: '是否开票',
          dataIndex: 'invoice',
          align: 'center',
          scopedSlots: { customRender: 'invoice' }
        },
        {
          title: '发票类型',
          dataIndex: 'invoiceType',
          align: 'center',
          scopedSlots: { customRender: 'invoiceType' }
        },
        {
          title: '税率承担方',
          dataIndex: 'taxpayer',
          align: 'center',
          scopedSlots: { customRender: 'taxpayer' }
        },
        {
          title: '承担税点',
          dataIndex: 'taxPoint',
          align: 'center'
        },
        // {
        //   title: '户名',
        //   dataIndex: 'accountName'
        // },
        // {
        //   title: '银行账号',
        //   dataIndex: 'accountNumber'
        // },
        // {
        //   title: '开户行',
        //   dataIndex: 'bankName'
        // },
        {
          title: '付款方式',
          dataIndex: 'payment',
          align: 'center',
          scopedSlots: { customRender: 'payment' }
        },
        {
          title: '禁用状态',
          dataIndex: 'forbiddenStatus',
          align: 'center',
          scopedSlots: { customRender: 'forbiddenStatus' }
        },
        {
          title: '新建人',
          dataIndex: 'createBy',
          align: 'center'
        },
        {
          title: '新建时间',
          dataIndex: 'createTime',
          align: 'center'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        parameter.createTime = this.createTime
        return getSupplierList(Object.assign(parameter, this.queryParam))
      },
      bankName: [
        { id: '中国工商银行', name: '中国工商银行' },
        { id: '中国银行', name: '中国银行' },
        { id: '中国建设银行', name: '中国建设银行' },
        { id: '中国农业银行', name: '中国农业银行' },
        { id: '交通银行', name: '交通银行' },
        { id: '中国邮政储蓄银行', name: '中国邮政储蓄银行' },
        { id: '招商银行', name: '招商银行' },
        { id: '上海浦东发展银行', name: '上海浦东发展银行' },
        { id: '民生银行', name: '民生银行' },
        { id: '兴业银行', name: '兴业银行' },
        { id: '中信银行', name: '中信银行' },
        { id: '平安银行', name: '平安银行' },
        { id: '光大银行', name: '光大银行' },
        { id: '华夏银行', name: '华夏银行' },
        { id: '广发银行', name: '广发银行' },
        { id: '上海银行', name: '上海银行' },
        { id: '南京银行', name: '南京银行' },
        { id: '渤海银行', name: '渤海银行' },
        { id: '江苏银行', name: '江苏银行' },
        { id: '恒丰银行', name: '恒丰银行' },
        { id: '徽商银行', name: '徽商银行' },
        { id: '国家开发银行', name: '国家开发银行' },
        { id: '上海农村商业银行', name: '上海农村商业银行' },
        { id: '农村信用社', name: '农村信用社' },
        { id: '农村合作银行', name: '农村合作银行' }
      ],
      selectedRowKeys: [],
      selectedRows: [],
      addEnable: checkPermission('addSupplier'),
      editEnabel: checkPermission('editSupplier'),
      removeEnable: checkPermission('deleteSupplier'),
      detailsEnabel: checkPermission('SupplierInfo')
    }
  },
  filters: {},
  async created() {
    // 配件规格
    selectAccessorySpecification().then(res => {
      console.log(res)
      this.dataSpecification = res.rows
    })

    // 配件型号
    selectAccessoryCategory().then(res => {
      console.log(res)
      this.dataCategory = res.rows
    })

    // 配件名称
    selectAccessoryName().then(res => {
      console.log(res)
      this.dataName = res.rows
    })

    // 配件类型
    selectAccessoryType().then(res => {
      console.log(res)
      this.dataType = res.rows
    })

    document.body.addEventListener('keyup', e => {
      if (e.keyCode == 13) {
        this.$refs.table.refresh(true)
      }
    })

    selectAllProvince().then(res => {
      console.log(res)
      this.selectAllProvince = res.rows
      this.selectAllProvince2 = res.rows
    })
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleSubmit2() {
      this.dateModel = false
    },
    handleSubmit3() {
      this.visible2 = false
    },

    handClear() {
      this.queryParam = {}
      this.times = ''
      this.createTime = ''
    },

    onchange2(value) {
      console.log(value)
      var provinceCode = value
      selectCityName({ provinceCode: provinceCode }).then(res => {
        console.log(res)
        this.selectCityName2 = res.rows
      })
    },

    onchange3(value) {
      console.log(value)
      var provinceCode = value
      selectCityName({ provinceCode: provinceCode }).then(res => {
        console.log(res)
        this.selectCityName3 = res.rows
      })
    },
    // 配件
    detailBtn2() {
      this.visible2 = true
      selectaccessory().then(res => {
        console.log(res)
        this.data2 = res.rows
      })
    },

    // 需求时间
    onChangeTiem(time, timeString) {
      this.createTime = timeString
      console.log(time, timeString)
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    detailBtn(ids) {
      console.log(ids)
      this.dateModel = true
      //this.idsLis = ids
      const supplierId = {
        supplierId: ids
      }
      getonesupplier(supplierId).then(res => {
        console.log(res)
        if (res.msg !== 'success') return
        this.boxLis = res.data
        // 配件
        this.supplierAreas = res.data.supplierAreas
        if (res.data.invoice == 0) {
          this.boxLis.invoice = '不开票'
        } else {
          this.boxLis.invoice = '开票'
        }
        if (res.data.invoiceType == 0) {
          this.boxLis.invoiceType = '无'
        } else if (res.data.invoiceType == 1) {
          this.boxLis.invoiceType = '不增值税普票'
        } else {
          this.boxLis.invoiceType = '增值税专票'
        }
        if (res.data.payment == 0) {
          this.boxLis.payment = '先付款'
        } else {
          this.boxLis.payment = '后付款'
        }

        selectCityName({ provinceCode: res.data.currentProvince }).then(res => {
          console.log(res)
          this.selectCityName2 = res.rows
        })
        this.currentCity2 = res.data.currentCity

        selectCityName({ provinceCode: res.data.deliveryProvince }).then(res => {
          console.log(res)
          this.selectCityName3 = res.rows
        })
        this.deliveryCity2 = res.data.deliveryCity

        console.log(this.boxLis)
      })
    },
    handleAdd() {
      this.$refs.modal.add()
    },
    handleEdit(record) {
      console.log('record', record)
      if (record.forbiddenStatus == 1) {
        this.$message.success('该供应商已禁用')
      } else {
        console.log(1111)
        this.$refs.modal.add()
        this.$refs.modal.edit(record)
      }
    },
    handleOk(userDefined) {
      console.log('userDefind', userDefined)
      if (userDefined[0] == 1) {
        this.$refs.table.refresh(false)
      } else {
        this.$refs.table.refresh(true)
      }
      console.log('handleSaveOk')
    },

    // 删除
    delByIds(record) {
      let that = this
      if (record.forbiddenStatus == 1) {
        that.$message.success('该供应商已禁用')
      } else {
        this.$confirm({
          title: '删除',
          content: '您确定删除本数据吗？',
          okType: 'danger',
          onOk() {
            var delFlag = that.delFlag
            delSupplier({ supplierId: record.supplierId, delFlag: 1 }).then(res => {
              if (res.code === 0) {
                that.$message.success('删除成功')
                this.$refs.table.refresh(false)
              } else {
                that.$message.error(res.msg)
              }
              that.selectedRowKeys = []
            })
          },
          onCancel() {
            console.log('Cancel')
          }
        })
      }
    },

    delById(record) {
      var forbiddenStatus = record.forbiddenStatus
      if (record.forbiddenStatus == '0') {
        var forbiddenStatus = '1'
      } else {
        var forbiddenStatus = '0'
      }
      var supplierId = record.supplierId
      forbiddenSupplier({ supplierId: supplierId, forbiddenStatus: forbiddenStatus }).then(res => {
        console.log(res)
        if (res.code === 0) {
          if (record.forbiddenStatus == '0') {
            record.forbiddenStatus = '1'
            this.$message.success('禁用成功')
          } else {
            record.forbiddenStatus = '0'
            this.$message.success('启用成功')
          }
          // this.handleOk()
        } else {
          this.$message.error(res.msg)
        }
        this.selectedRowKeys = []
      })
    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
</style>
